import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SERVICES_SECTION = { pathname: '/', hash: '#services' };

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="w-full min-w-0 border-t border-purple-dark bg-core-black">
      <div className="mx-auto flex min-w-0 max-w-7xl flex-col items-start gap-8 px-4 py-12 sm:px-6 md:flex-row md:justify-between">
        <div className="min-w-0">
          <Link to="/" className="block">
            <img src="/logo-official.svg" alt="CrossPay Solutions" className="h-10" />
          </Link>
          <p className="text-[10px] text-gray-500 mt-2 font-headline uppercase tracking-widest">
            {t('footer.tagline')}
          </p>
          <p className="text-sm text-on-surface-variant mt-4 max-w-xs">
            {t('footer.description')}
          </p>
          <p className="text-[10px] text-gray-500 mt-3 max-w-xs flex items-center gap-1.5">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
            Connected exclusively to regulated financial partners across multiple jurisdictions.
          </p>
        </div>

        <div className="flex min-w-0 flex-wrap gap-8 sm:gap-12">
          <div>
            <h4 className="text-sm font-bold font-headline uppercase tracking-widest mb-4">Platform</h4>
            <div className="flex flex-col gap-2">
              <Link to={SERVICES_SECTION} className="text-sm text-gray-400 hover:text-accent-magenta transition-colors">Cross-Border Payments</Link>
              <Link to={SERVICES_SECTION} className="text-sm text-gray-400 hover:text-accent-magenta transition-colors">Payment Acquiring</Link>
              <Link to={SERVICES_SECTION} className="text-sm text-gray-400 hover:text-accent-magenta transition-colors">Compliance & AML</Link>
              <Link to={SERVICES_SECTION} className="text-sm text-gray-400 hover:text-accent-magenta transition-colors">AI Agents</Link>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-bold font-headline uppercase tracking-widest mb-4">Legal / Docs</h4>
            <div className="flex flex-col gap-2">
              <Link to="/privacy" className="text-sm text-gray-400 hover:text-accent-magenta transition-colors">{t('footer.legal.privacy')}</Link>
              <Link to="/terms" className="text-sm text-gray-400 hover:text-accent-magenta transition-colors">{t('footer.legal.terms')}</Link>
              <Link to="/pqr-habeas-data" className="text-sm text-gray-400 hover:text-accent-magenta transition-colors">PQR Habeas Data</Link>
              <a
                href="https://docs.crosspaysolutions.app/resumen"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-gray-400 hover:text-accent-magenta transition-colors"
              >
                Documentación API
              </a>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-bold font-headline uppercase tracking-widest mb-4">Contact</h4>
            <div className="flex flex-col gap-2 text-sm text-gray-400">
              <a href="mailto:operations@crosspaysolutions.com" className="hover:text-accent-magenta transition-colors">operations@crosspaysolutions.com</a>
              <a href="https://wa.me/573114455762" className="hover:text-accent-magenta transition-colors" target="_blank" rel="noopener noreferrer">+57 311 445 5762</a>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto flex min-w-0 max-w-7xl flex-col items-center gap-4 border-t border-purple-dark/50 px-4 py-4 sm:px-6 md:flex-row md:justify-between">
        <div className="flex gap-4">
        </div>
        <p className="text-[10px] text-gray-500 uppercase tracking-widest font-headline">
          {t('footer.copyright', { year })}
        </p>
      </div>
    </footer>
  );
}
